module.exports = __webpack_public_path__ + "static/media/iprofile-logo.e1daeac5.png";